// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export default {
  'mifos_x': {
    'version': '0.0.0',
    'hash': 'e0be899'
  },
  'allow_switching_backend_instance': true
};
/* tslint:enable */
